import { Shield, Heart, MapPin, Sparkles } from "lucide-react";

const items = [
  { icon: Heart, label: "Locally Family Owned" },
  { icon: Shield, label: "Reliable & Respectful" },
  { icon: Sparkles, label: "Woman-Owned & Operated" },
  { icon: MapPin, label: "Serving All of NWI" },
];

export default function TrustBar() {
  return (
    <section className="bg-[#E0F2FE]/60 border-y border-sky-100">
      <div className="container-ss py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-3 text-[#0B1A3F]"
              data-testid={`trust-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              <span className="h-9 w-9 rounded-xl bg-white inline-flex items-center justify-center text-[#1E3A8A] border border-sky-100">
                <Icon size={18} />
              </span>
              <span className="text-sm md:text-[15px] font-semibold leading-tight">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
